import Vue from 'vue';
import Component from 'vue-class-component';
import { mapGetters } from 'vuex';
@Component({
  computed: {
    ...mapGetters(['account', 'selectedRole']),
  },
})
export default class DataUserComponent extends Vue {
  public mainProps = {
    blank: true,
    blankColor: '#777',
    width: 75,
    height: 75,
    class: 'm1',
  };

  public scrollPosition: number = window.scrollY;
  private lastScrollY: number = window.scrollY;
  private currentHeaderState: 'muestra' | 'esconde' = 'muestra';
  public account;
  public selectedRole;

  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  }

  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  private handleScroll() {
    const currentScrollY = window.scrollY;
    const threshold = 10;

    if (currentScrollY - this.lastScrollY > threshold) {
      if (this.currentHeaderState !== 'esconde') {
        this.currentHeaderState = 'esconde';
      }
    } else if (this.lastScrollY - currentScrollY > threshold) {
      if (this.currentHeaderState !== 'muestra') {
        this.currentHeaderState = 'muestra';
      }
    }

    this.scrollPosition = currentScrollY;
    this.lastScrollY = currentScrollY;
  }

  get headerClasses() {
    return [this.currentHeaderState];
  }

  public get foto(): string {
    const uri = this.$store.getters.perfil?.fotografia?.uri ?? '';
    return uri != '' ? `${uri}/preview` : '../../../content/images/foto-empty1.svg';
  }
}
